import Loading from "components/commons/Loading"
import { useGetMyWorkerLeaveReportQuery } from "../api/workContractApiSlice"
import LeaveReportTable from "../views/LeaveReportTable"

export default function MyWorkerLeaveReport() {

    const  {
        data: leaveReport,
        isSuccess,
        isError,
        isLoading,
        isFetching,
    } = useGetMyWorkerLeaveReportQuery()

    let content

    if(isSuccess){
        content =  <LeaveReportTable leaveReport={leaveReport} showRatios={false} showAvailability={true}/>      
    }

    if(isLoading || isFetching){
        content = <Loading/>
    }

    return content
}